import Link from "next/link";
import React from "react";
import { APP_URL } from "@/app/utilities/constants";

// Default classes mirror the base (no bgGreen/customClass/similarBrandsLayout/
// reducedPadding/inline modifiers) rendering that ChipsBlock.module.css used to
// produce, for any caller that doesn't pass explicit variant classes.
const DEFAULT_COL_CLASS_NAME =
  "flex-none px-2 w-auto min-w-[120px] max-w-none max-[991px]:w-1/2 max-[991px]:min-w-[50%]";
const DEFAULT_BLOCK_CLASS_NAME =
  "text-center text-[14px] leading-[32px] my-[3px] rounded-[7px] !font-medium text-[#6f6f6f] border border-[#6f6f6f] hover:text-[#008c8b] hover:bg-[#008c8b0d] hover:border-[0.4px] hover:border-[#008c8b] py-2 px-8 max-[991px]:py-1 max-[991px]:px-4 min-[420px]:max-[480px]:px-3 max-[991px]:overflow-hidden max-[991px]:text-ellipsis max-[991px]:cursor-pointer max-[991px]:text-[13px] min-[420px]:max-[480px]:text-[12px]";

interface ChipsBlockProps {
  href?: string;
  title: string;
  label: string;
  trackingClass?: string;
  colClassName?: string;
  blockClassName?: string;
}

const ChipsBlock: React.FC<ChipsBlockProps> = ({
  href = "/",
  title,
  label,
  trackingClass,
  colClassName = DEFAULT_COL_CLASS_NAME,
  blockClassName = DEFAULT_BLOCK_CLASS_NAME,
}) => {
  return (
    <div className={`${colClassName} cj-col`}>
      <Link prefetch={false} href={APP_URL + href} title={title} className={`${blockClassName} block font-bold text-center whitespace-nowrap ${trackingClass}`} >
        {label}
      </Link>
    </div>
  );
};

export default ChipsBlock;
